import styled from 'styled-components';

const MOBILE = '@media (max-width: 768px)';

export const AnnouncementBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.accentDark},
    ${({ theme }) => theme.colors.accent}
  );
  color: ${({ theme }) => theme.colors.overlayText};
  text-align: center;
  padding: 1rem 1.6rem;
  font-size: 1.3rem;
  font-weight: 600;
  letter-spacing: 0.01rem;
  line-height: 1.4;

  ${MOBILE} {
    font-size: 1.2rem;
    padding: 0.8rem 1.2rem;
  }
`;

export const AnnouncementAccent = styled.span`
  font-weight: 800;
`;

export const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 96rem;
  margin: 0 auto;
  padding: ${({ theme }) => `${theme.spacing.lg} ${theme.spacing.lg}`};
`;

export const NavLogo = styled.span`
  font-size: 2.2rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.accent};
  text-decoration: none;
`;

export const NavRight = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md};
`;

export const PersonaChip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background-color: ${({ theme }) => theme.colors.accentLight};
  color: ${({ theme }) => theme.colors.accentTextDark};
  border: 0.1rem solid ${({ theme }) => theme.colors.accentBorder};
  border-radius: 999rem;
  padding: 0.5rem 1.2rem;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const SectionBand = styled.div<{ $variant: 'white' | 'grey' }>`
  width: 100%;
  background-color: ${({ theme, $variant }) =>
    $variant === 'grey' ? theme.colors.surfaceSoft : theme.colors.white};
`;
